export default {
  title: 'Create a new password',
  savePassword: 'Save password',
};
